/**
 * chain-eos/proxy-base.ts — where our own server-side proxies live.
 *
 * The web build serves /ipfs-proxy, /paycash-*-proxy and /api/* on its own
 * origin (Vercel rewrites + vite dev middleware), so relative paths just work.
 *
 * The native Capacitor app does NOT: its origin is https://localhost and there
 * is no server behind it. A relative "/paycash-auth-proxy" there hits the
 * WebView's SPA fallback and returns index.html — hence "Unexpected token '<',
 * "<!doctype "... is not valid JSON" when sending a photo, broken NFT previews
 * (every IPFS image goes through /ipfs-proxy) and silently failing push
 * registration. The app sets an absolute base at startup on native platforms;
 * the Vercel functions answer it with CORS for the localhost origins.
 */

let proxyBase = ''

/** Set once at app startup (native only). Pass '' to go back to same-origin. */
export function setProxyBaseUrl(url: string): void {
  proxyBase = String(url ?? '').trim().replace(/\/+$/, '')
}

export function getProxyBaseUrl(): string {
  return proxyBase
}

/** Absolute (native) or same-origin (web) URL for one of our proxy paths. */
export function proxyUrl(path: string): string {
  const p = path.startsWith('/') ? path : `/${path}`
  return `${proxyBase}${p}`
}
